<template>
  <v-container>
    <material-card>
      <v-layout slot="header" px-3>
        <v-flex mt-2 pl-3 align-center justify-center>
          <div class="headline">Role</div>

          <p>Drzewo ról użytkownika</p>
        </v-flex>
      </v-layout>

      <v-treeview ref="treeview" :items="tree" :open-all="true">
        <template v-slot:append="{ item }">
          <div>
            <check-permission
              v-if="item.isAssigned"
              join-type="OR"
              entity-type="profile"
              :entity-id="userId"
              :permissions="['USER.ROLE_MANAGE']"
            >
              <v-btn icon flat color="error" @click="idToDelete = item.id">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </check-permission>

            <check-permission
              v-if="!item.isAssigned"
              join-type="OR"
              entity-type="profile"
              :entity-id="userId"
              :permissions="['USER.ROLE_MANAGE']"
            >
              <v-btn icon flat color="primary" @click="idToAdd = item.id">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </check-permission>
          </div>
        </template>

        <template v-slot:label="{ item }">
          <div class="v-treeview-node__label">
            {{ item.name }}
            <small v-if="item.isAssigned">(Posiadana)</small>
          </div>
        </template>
      </v-treeview>
    </material-card>

    <material-dialog
      :id="idToDelete"
      title="Potwierdź usunięcie"
      text="Czy na pewno chcesz usunąć użytkownikowi rolę?"
      :show="!!idToDelete"
      @close="hideDialog"
      @confirm="remove"
    />

    <material-dialog
      :id="idToAdd"
      title="Potwierdź dodanie"
      text="Czy na pewno chcesz dodać rolę do użytkownika"
      :show="!!idToAdd"
      @close="hideDialog"
      @confirm="add"
    />
  </v-container>
</template>
<script>
import { SessionStorage } from '@witkac/kartamiejska-shared';
// import { formatError } from '@witkac/kartamiejska-shared/dist/filters/formatError';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';

// @vuese
// Wyświetlanie drzewa ról danego użytkownika
// @group Roles
export default {
  components: {
    MaterialCard,
    MaterialDialog
  },
  data() {
    return { idToDelete: undefined, idToAdd: undefined };
  },
  computed: {
    ...mapState({
      tree(state) {
        const userRoles = state.profiles.userRole.list;

        const roles = state.roles.list.map(role => ({
          ...role,
          isAssigned: userRoles.find(userRole => userRole.id === role.id)
        }));

        return roles.reduce((roots, role) => {
          if (!!role.parent) {
            const parent = roles.find(r => r.id === role.parent.id);
            parent ? this.addToParent(parent, role, roles) : roots.push(role);
          } else {
            roots.push(role);
          }
          return roots;
        }, []);
      }
    }),
    partnerId() {
      return localStorage.getItem(SessionStorage.PARTNER_ID);
    },
    userId() {
      return this.$route.params.employeeId ? this.$route.params.employeeId : this.$route.params.id;
    }
  },
  methods: {
    // @vuese
    // Usuwa rolę użytkownikowi
    remove(roleId) {
      //store.dispatch('notifyError', { title: 'Nie udało się pobrać danych Partnera' }
      this.$store.dispatch('profiles/userRole/remove', this.roleConfig(roleId)).catch(err => {
        this.$store.dispatch('notifyError', err);
      });
    },
    // @vuese
    // Dodaje rolę do użytkownika
    add(roleId) {
      this.$store.dispatch('profiles/userRole/add', this.roleConfig(roleId)).catch(err => {
        this.$store.dispatch('notifyError', err);
      });
    },
    // @vuese
    // Konfiguracja relacji roli
    roleConfig(roleId) {
      const roleConfig = { roleId, userId: this.userId };
      if (this.partnerId) {
        roleConfig.entityType = 'partner';
        roleConfig.entityId = this.partnerId.toString();
      }
      return roleConfig;
    },
    // @vuese
    // Zamyka dialog
    hideDialog() {
      this.idToDelete = undefined;
      this.idToAdd = undefined;
    },
    // @vuese
    // Ustawia rolę jako dziecko
    addToParent(parent, role, roles) {
      if (parent.children) {
        parent.children.push(role);
      } else {
        parent.children = [role];
      }
    }
  }
};
</script>
